import { IArticleListItem, IFilter, IFilterGroup } from '../shared/shared-types';

export interface ICategoryLandingPageProps {
    config: ICategoryLandingConfig
}

export interface ICategoryLandingPageState extends ICategoryLandingFilterState {
    isLoading: boolean,
    mobileFiltersAreOpen: boolean,
    selectedCategory: CategoryFilterType,
    selectedLetter: string,
    selectedBodyPart: number,
    selectedTopics: Array<number>,
    selectedLanguage: Array<string>,
}

export interface ICategoryLandingFilterState {
    page: number,
    totalPages: number,
    articles: Array<IArticleListItem>,    
    availableLetters: Array<string>,
    availableBodyParts: Array<number>,
    availableTopics: Array<number>,
    availableLanguages: Array<string>
}

export interface ICategoryLandingUrlState {
    topic?: string,
    bodyPart?: string
}

export interface ICategoryLandingFilterAction {
    page: number,
    category: CategoryFilterType,
    letter: string,
    bodyPart: number,
    topics: Array<number>,
    language: Array<string>
}

export interface ICategoryLandingConfig {
    globalPropName: string,
    inEditMode: string,
    apiEndpoint: string,
    categoryName: string,
    categoryTheme: string,
    mobileBreakpoint: number,
    articleList: {        
        pageSize: number,
        mobilePageSize: number,
        noResultMessage: string
    }
    filters: {
        filterHeader: string,
        allContentHeader: string,
        alphabetHeader: string,
        categories: IFilterGroup,
        bodyParts: IFilterGroup,
        topics: IFilterGroup,
        languages: IFilterGroup,
        controls: {
            clearButtonText: string,
            doneButtonText: string,
            applyButtonText: string
        }
    }    
}

export enum CategoryFilterType {
    ALL,
    ALPHABETICAL,
    BODYPART
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/clp/category-landing-types.ts